import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ion-padding payment-success-block" }
const _hoisted_2 = { class: "payment-success-icon-wrap" }
const _hoisted_3 = { class: "payment-success-text" }
const _hoisted_4 = { class: "payment-success-icon-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/showcase"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Оплата", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.paymentState === 'checking')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ion_spinner, {
                    name: "crescent",
                    class: "payment-status-spinner"
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "payment-success-title" }, "Проверяем оплату", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "payment-success-text" }, "Подождите, уточняем статус платежа…", -1))
                ], 64))
              : (_ctx.paymentState === 'paid')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.checkmarkCircleOutline,
                        class: "payment-success-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "payment-success-title" }, "Оплата прошла", -1)),
                    _createElementVNode("p", _hoisted_3, [
                      (_ctx.isSubscriptionPurchase)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" Спасибо за оплату. Подписка активирована. Если статус не обновился, откройте «Мои подписки». ")
                          ], 64))
                        : (_ctx.isReleasePurchase)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Спасибо за оплату. Доступ к релизу подтверждён. Если контент не открылся, вернитесь в раздел «Релизы от Лиги». ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(" Спасибо за оплату. Регистрация на событие подтверждена. ")
                            ], 64))
                    ]),
                    (_ctx.isSubscriptionPurchase)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          expand: "block",
                          class: "event-register-btn",
                          onClick: _ctx.goToMySubscriptions
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" Мои подписки ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (!_ctx.isReleasePurchase)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 1,
                            expand: "block",
                            class: "event-register-btn",
                            onClick: _ctx.goToEvents
                          }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode(" К событиям ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                    (_ctx.isReleasePurchase)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 2,
                          expand: "block",
                          class: "event-register-btn",
                          onClick: _ctx.goToPrograms
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" К релизам ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSubscriptionPurchase && _ctx.subscriptionId)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 3,
                          expand: "block",
                          fill: "outline",
                          class: "event-detail-btn",
                          onClick: _ctx.goToSubscription
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Вернуться к подписке ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isReleasePurchase && !_ctx.isSubscriptionPurchase && _ctx.eventId)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 4,
                          expand: "block",
                          fill: "outline",
                          class: "event-detail-btn",
                          onClick: _ctx.goToEvent
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode(" Вернуться к событию ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.closeCircleOutline,
                        class: "payment-pending-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "payment-success-title" }, "Оплата не завершена", -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "payment-success-text" }, " Вы вернулись со страницы оплаты без подтверждения платежа. Если деньги всё же списались, подождите минуту и нажмите «Проверить снова». ", -1)),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      class: "event-register-btn",
                      disabled: _ctx.checkingAgain,
                      onClick: _ctx.checkPaymentStatus
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.checkingAgain ? 'Проверяем…' : 'Проверить снова'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      fill: "outline",
                      class: "event-detail-btn",
                      onClick: _ctx.goBackToSource
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.backButtonLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}